import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal, toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { getHelpMobileIdParams } from 'apps/auth/components/utils/AmplitudeUtils';
import { GET_CHAT_CLICKED, GET_HELP_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PS_BONUS_INCOMING } from 'apps/auth/constants/Constants';
import { AUTH_CANCEL_TRANSACTION } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { useThemeDetector } from 'apps/auth/hooks/theme';

import CanceledOperationModal from '../cheque/modals/CanceledOperationModal';

const SendMorePopup = ({ popupRef = null, ...props }) => {
    const cheque = props.cheque;
    const { theme } = useThemeDetector();
    const messages = usePageMessages();

    const getMenuItemsForBill = () => {
        return (
            <>
                <PopupButton
                    text={props.chequeEmailDetailsButton}
                    iconName="document"
                    id={`ivanbutton-send_email_${cheque.paymentId}`}
                    onClick={(e) => {
                        e.preventDefault();
                        popupRef.current.close();
                        props.showEmailPopup();
                    }}
                />
            </>
        );
    };

    const getMenuItemsForBonus = () => {
        return false;
    };

    const getMenuItemsForDraft = () => {
        return (
            <PopupButton
                text={props.draftCancel}
                iconName="cross"
                id={`ivanbutton-cancel_${cheque.id}`}
                onClick={(e) => {
                    e.preventDefault();
                    popupRef.current.close();
                    props.toggleSpinner(true);
                    apiFetchData(AUTH_CANCEL_TRANSACTION + '?paymentId=' + cheque.paymentId)
                        .then((json) => {
                            if (json.messageBodyMessages) {
                                props.updateMessages(json.messageBodyMessages);
                            }
                            props.updatePageMessages(json.messages).then(() => {
                                if (json.extra.transactionCanceled) {
                                    props.toggleModal(true, <CanceledOperationModal />, false);
                                }
                            });
                        })
                        .finally(() => props.toggleSpinner(false))
                        .catch((error) => {
                            logWarn(error);
                        });
                }}
            />
        );
    };

    const getMenuItemsForOther = () => {
        return (
            <>
                <PopupButton
                    text={props.chequeRenameOperation}
                    iconName="pencil"
                    id={`ivanbutton-rename_${cheque.paymentId}`}
                    onClick={(e) => {
                        e.preventDefault();
                        popupRef.current.close();
                        props.showRenamePopup();
                    }}
                />
                <PopupButton
                    text={props.chequeEmailDetailsButton}
                    iconName="document"
                    id={`ivanbutton-send_email_${cheque.paymentId}`}
                    onClick={(e) => {
                        e.preventDefault();
                        popupRef.current.close();
                        props.showEmailPopup();
                    }}
                />
                {cheque?.extra?.fromRRN && (
                    <PopupButton
                        text={props.proofButton}
                        iconName="document"
                        id={`ivanbutton-send_email_${cheque.paymentId}`}
                        onClick={(e) => {
                            e.preventDefault();
                            popupRef.current.close();
                            props.showRrnPopup();
                        }}
                    />
                )}
            </>
        );
    };

    const getMenuItems = () => {
        if (cheque.billId && cheque.billId !== 0) {
            return getMenuItemsForBill();
        } else if (cheque.transactionType === PS_BONUS_INCOMING) {
            return getMenuItemsForBonus();
        } else if (cheque.draft) {
            return getMenuItemsForDraft();
        } else {
            return getMenuItemsForOther();
        }
    };

    return (
        <>
            <SimplePopup withoutBorder popupRef={popupRef}>
                {getMenuItems()}
                {props.showSupportChat && (
                    <PopupButton
                        iconName="message-bubble"
                        text={props.morePopupChatTitle}
                        onClick={(e) => {
                            e.preventDefault();
                            amplitude.getInstance().logEvent(GET_CHAT_CLICKED);
                            popupRef.current?.close();
                            props.toggleChat(true);
                        }}
                    />
                )}
                <PopupButton
                    text={messages.morePopupGetHelpButton}
                    iconName="lifebuoy"
                    href={`${getLangCountryPrefix(props.lang, props.country)}${props.faqUrl}?mode=${theme}`}
                    onClick={() => {
                        amplitude.getInstance().logEvent(GET_HELP_CLICKED, getHelpMobileIdParams(props.faqUrl));
                    }}
                />
            </SimplePopup>
        </>
    );
};

SendMorePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => ({
    cheque: state.history.cheque.cheque,
    morePopupSupportTitle: state.messages.pageMessages.morePopupSupportTitle,
    morePopupChatTitle: state.messages.pageMessages.morePopupChatTitle,
    chequeRenameOperation: state.messages.pageMessages.chequeRenameOperation,
    proofButton: state.messages.pageMessages.proofButton,
    chequeEmailDetailsButton: state.messages.pageMessages.chequeEmailDetailsButton,
    draftCancel: state.messages.pageMessages.cancelAchTransferCancel,
    lang: state.language.lang,
    userCountry: state.extra?.userCountry,
    country: state.app.country,
});
export default connect(mapStateToProps, { toggleModal, updateMessages, updatePageMessages, toggleSpinner, toggleChat })(SendMorePopup);
